<section class="container">
	<div class="flex flex-col bg-white sm:border-t divider">
		<div class="relative overflow-hidden">
			<a routerLink="/directory" class="block w-full h-full rounded-2xl">
				<uc-engage-card-cta-img
					backgroundImageClass="bg-course-search-directory-cta"
				/>
			</a>

			<div class="relative pt-6 mx-auto md:py-12 max-w-7xl">
				<div class="lg:px-5 md:ml-auto md:w-1/2 md:pl-8 lg:pl-16">
					<p class="flex flex-wrap-reverse mt-2 tracking-tight">
						<a routerLink="/directory" class="text-2xl font-bold md:text-3xl">
							Directory
						</a>
					</p>
					<p class="mt-4 mb-8 text-base text-gray-500">
						Looking for more? Discover the A-Z of subjects in the directory.
					</p>
					<a
						routerLink="/directory"
						class="inline-block w-full blue-button md:w-auto"
					>
						View All Subjects
					</a>
				</div>
			</div>
		</div>
	</div>
</section>
